export default {
    mediaGroupSite: 'media/group-sites',
    mediaPreviewObject: '/media/preview-objects',
    mediaEditData: '/media/edit-data',
    mediaSaveEditData: '/media/save-edit-data',
    mediaSend: '/media/send',
    mediaProperty: '/media/properties',
    mediaContextMenu: 'media/context-menus',
    mediaStatistic: 'media/statistic',
    mediaEmailIn: 'media/emailIn',
    mediaLookupCurrentUsed: 'media/lookup-current-used-media',
    mediaLookupExternal: 'media/external-media-ids'
}